import type { GoogleLocation } from '../api/GoogleLocationAPI.model'

/**
 * Whether a URL is a Google map we are willing to frame.
 *
 * The embed URL comes from the backend and is copied into a published page,
 * so it is checked rather than trusted: an iframe that loads whatever a
 * payload says is an open embed. Google's own host and its `/maps` path,
 * over https, and nothing else.
 */
export function isGoogleMapsEmbedUrl(value: string): boolean {
  try {
    const url = new URL(value)
    return (
      url.protocol === 'https:' &&
      url.hostname === 'www.google.com' &&
      (url.pathname === '/maps' || url.pathname.startsWith('/maps/'))
    )
  } catch {
    return false
  }
}

/**
 * The map a page shows for the venue: the connected place's, or none while
 * nothing is connected or Google no longer recognises the place.
 */
export function restaurantMapUrl(location: GoogleLocation | null | undefined) {
  return location?.status === 'active' &&
    isGoogleMapsEmbedUrl(location.embedUrl)
    ? location.embedUrl
    : ''
}
